import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function SocialYoutubeIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path fillRule="evenodd" clipRule="evenodd" d="M21.5818 6.84194C21.3523 5.92016 20.6739 5.19435 19.8136 4.94758C18.2545 4.5 12 4.5 12 4.5C12 4.5 5.74545 4.5 4.18636 4.94758C3.32614 5.19435 2.64773 5.92016 2.41818 6.84194C2 8.51371 2 12 2 12C2 12 2 15.4863 2.41818 17.1581C2.64773 18.0798 3.32614 18.8056 4.18636 19.0524C5.74659 19.5 12 19.5 12 19.5C12 19.5 18.2545 19.5 19.8136 19.0524C20.6739 18.8056 21.3523 18.0798 21.5818 17.1581C22 15.4875 22 12 22 12C22 12 22 8.51371 21.5818 6.84194ZM10 14.5L15 12L10 9.5V14.5Z" fill={color}/>
        </svg>
    );
}

export default SocialYoutubeIcon;
